import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function LatestNews() {
  const latestArticles = articles
    .filter((a) => a.category === 'latest' || a.featured)
    .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
    .slice(0, 4);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-7xl mx-auto">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between mb-10 gap-4">
          <div>
            <p className="text-primary-500 text-xs tracking-[0.2em] uppercase mb-2 font-label">Latest News</p>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
              最新动态
            </h2>
          </div>
          <Link
            to="/category/latest"
            className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium transition-colors whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line text-sm"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-5">
          {latestArticles.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group flex flex-col sm:flex-row gap-4 bg-background-50 border border-background-200/70 rounded-lg p-4 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-full sm:w-48 h-32 flex-shrink-0 rounded-md overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  title={`友田真希 ${article.title}`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex-1 min-w-0 flex flex-col justify-between">
                <div>
                  <div className="flex items-center gap-2 mb-2 flex-wrap">
                    <span className="text-xs px-2 py-0.5 rounded-full bg-primary-50 text-primary-600 whitespace-nowrap">
                      {article.category === 'latest' ? '最新动态' : article.category === 'events' ? '艺能活动' : article.category === 'works' ? '作品集锦' : '资讯'}
                    </span>
                    <span className="text-xs text-foreground-500">{article.date}</span>
                  </div>
                  <h3 className="font-heading text-base font-semibold text-foreground-950 group-hover:text-primary-500 transition-colors line-clamp-2 mb-1">
                    {article.title}
                  </h3>
                  <p className="text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                    {article.excerpt}
                  </p>
                </div>
                <p className="text-xs text-foreground-500 mt-2">
                  阅读时间 {article.readTime} 分钟
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}